import { addToListsIntentSchema, type AddToListsIntent } from "@/lib/add-to-lists-intent";
import { Cookies } from "@garimpa/lib/cookies";
import { readCookie } from "@garimpa/lib/readCookie";

export function readAddToListsIntent(): AddToListsIntent | null {
  if (typeof document === "undefined") return null;

  const value = readCookie(document.cookie, Cookies.addToListsIntent);
  if (!value) return null;

  try {
    const parsed = addToListsIntentSchema.safeParse(JSON.parse(value));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
